import { render } from "./PlantDashboardRoom.vue?vue&type=template&id=c960781a&ts=true"
import script from "./PlantDashboardRoom.ts?vue&type=script&lang=ts"
export * from "./PlantDashboardRoom.ts?vue&type=script&lang=ts"

import "./PlantDashboardRoom.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__